import ExamAddWizard from "../../components/Exams/ExamAddWizard"

const ExamAdd = () => <ExamAddWizard />

export default ExamAdd